import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { Link, useHistory, useLocation } from "react-router-dom"
import {
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Label,
  Row,
  Card,
  CardImg,
  CardTitle,
} from "reactstrap"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import * as url from "helpers/url_helper"
import SweetAlert from "react-bootstrap-sweetalert"

//i18n
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"

import card1 from "assets/images/ugifts/dummyBanner/card1.png"
import card2 from "assets/images/ugifts/dummyBanner/card2.png"
import logofilter from "assets/images/ugifts/dummyBanner/filter.png"
import logosort from "assets/images/ugifts/dummyBanner/sort.png"
import { Button } from "@material-ui/core"

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

const CardProducts = props => {
  const history = useHistory()
  const query = useQuery()

  const [token, setToken] = useState(null)
  const [uid, setUid] = useState(null)
  const [sortType, setSortType] = useState("ASC")
  const [giftcardId, setGiftcardId] = useState(null)
  const [currency, setCurrency] = useState("")
  const [basketCount, setBasketCount] = useState(null)
  const [country, setCountry] = useState("")
  const [isGuest, setIsGuest] = useState(false)

  useEffect(() => {
    if (localStorage.getItem("authAPI")) {
      const obj = JSON.parse(localStorage.getItem("authAPI"))
      console.log(
        "storage",
        obj.api_token_expiry + " / " + Math.floor(Date.now() / 1000)
      )
      if (obj.api_token_expiry < Math.floor(Date.now() / 1000)) {
        getToken()
      } else {
        setToken(obj)
      }
    } else {
      getToken()
    }

    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"))
      setUid(obj.member_id)
      console.log(obj)
    } else {
      setIsGuest(true)
    }

    if (query.get("id")) {
      setGiftcardId(query.get("id"))
    }

    if (localStorage.getItem("currency")) {
      setCurrency(localStorage.getItem("currency"))
    }

    if (localStorage.getItem("basketCount")) {
      setBasketCount(localStorage.getItem("basketCount"))
    }

    if (localStorage.getItem("country")) {
      setCountry(localStorage.getItem("country"))
    }

    if (localStorage.getItem("I18N_LANGUAGE")) {
      setLanguage(localStorage.getItem("I18N_LANGUAGE"))
    }
  }, [])

  const getToken = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "get_api_token")
    urlencoded.append("source", "web")
    urlencoded.append("api_key", process.env.REACT_APP_APIKEY)

    const requestOptions = {
      method: "POST",
      body: urlencoded,
    }

    console.log("Request token", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_POST_AUTH, requestOptions)
    const postresponse = await response.json()

    console.log(response.status, postresponse.message)

    if (response.status == 200 && postresponse.success) {
      setToken(postresponse)
      localStorage.setItem("authAPI", JSON.stringify(postresponse))
      console.log(response.status, token)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (token && country) {
      getGiftList()
      if (!isGuest) getBasketData()
      console.log("use effect")
    }
  }, [token, country])

  const [giftData, setGiftData] = useState(null)
  const getGiftList = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_giftcard")
    urlencoded.append("member_id", uid)
    urlencoded.append("order_by", sortType)
    urlencoded.append("giftcard_id", giftcardId)
    urlencoded.append("filter_by_country_id", country)

    const requestOptions = {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request giftcard product", urlencoded.toString())

    const response = await fetch(url.UGIFT_STAGING_GIFT, requestOptions)
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      setGiftData(postresponse.table)
    } else {
      // seterror_alert(true)
    }
  }

  useEffect(() => {
    if (giftData) {
      if (!isGuest) updateGiftCardIdToBasket()
      console.log("use effect")
    }
  }, [giftData])

  const updateGiftCardIdToBasket = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "giftcard_to_basket")
    urlencoded.append("member_id", uid)
    urlencoded.append("giftcard_id", giftData.id)
    urlencoded.append("giftcard_edit_parameter", giftData.edit_parameter)
    // if (basketData.giftcard_id != giftcardId)
    //   urlencoded.append("giftcard_edit_parameter", giftData.edit_parameter)
    // else
    //   urlencoded.append(
    //     "giftcard_edit_parameter",
    //     basketData.giftcard_edit_parameter
    //   )

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request update gift data", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      // if (basketData.products.length == 0) {
      //   // history.push("/checkout-cardselection")
      //   updateOrderStatus()
      // } else {
      //   history.push("/basket")
      // }
      // setsuccess_dlg(true)
      // setdynamic_title("Cart Updated")
      // setdynamic_description(postresponse.message)
    } else {
      // seterror_alert(true)
      // setdynamic_title("Cart Update Failed")
      // setdynamic_description(postresponse.message)
    }
  }

  const updateGiftCardId = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "giftcard_to_basket")
    urlencoded.append("member_id", uid)
    urlencoded.append("giftcard_id", giftData.id)
    urlencoded.append("giftcard_edit_parameter", giftData.edit_parameter)
    // if (basketData.giftcard_id != giftcardId)
    //   urlencoded.append("giftcard_edit_parameter", giftData.edit_parameter)
    // else
    //   urlencoded.append(
    //     "giftcard_edit_parameter",
    //     basketData.giftcard_edit_parameter
    //   )

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request update gift data", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      if (basketData.products.length == 0) {
        // history.push("/checkout-cardselection")
        updateOrderStatus()
      } else {
        history.push("/basket")
      }
      // setsuccess_dlg(true)
      // setdynamic_title("Cart Updated")
      // setdynamic_description(postresponse.message)
    } else {
      seterror_alert(true)
      setdynamic_title(props.t("Cart Update Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const updateOrderStatus = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "update_order_status")
    urlencoded.append("member_id", uid)
    urlencoded.append("order_status", "gift") //gift or myself

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request update order status", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      // setBasketData(postresponse.table)
      // getBasketData()
      history.push("/checkout-cardselection")
      // setsuccess_dlg(true)
      // setdynamic_title("Basket Updated")
      // setdynamic_description(postresponse.message)
    } else {
      // seterror_alert(true)
      seterror_alert(true)
      setdynamic_title(props.t("Cart Update Failed"))
      setdynamic_description(postresponse.message)
    }
  }

  const [basketData, setBasketData] = useState(null)
  const getBasketData = async () => {
    var urlencoded = new URLSearchParams()
    urlencoded.append("option", "detail_basket")
    urlencoded.append("member_id", uid)

    const requestOptions = {
      method: "POST",
      // mode: "no-cors",
      headers: {
        // "Content-Type": "application/json",
        Authorization: "Bearer " + token.api_token,
      },
      body: urlencoded,
    }

    console.log("Request basket", urlencoded.toString())

    const response = await fetch(
      url.UGIFT_STAGING_BASKET,
      // "http://47.241.176.8/api/external/auth/",
      requestOptions
    )
    const postresponse = await response.json()
    // response.body
    // setPostResponse(postresponse)
    console.log(response.status, postresponse)

    if (response.status == 200) {
      // history.push("/tables-applicationtable")
      var calculate = 0
      postresponse.table.products.forEach(product => {
        calculate += parseInt(product.quantity)
      })
      localStorage.setItem("basketCount", calculate)
      setBasketCount(calculate)
      setBasketData(postresponse.table)
    } else {
    }
  }

  const [success_dlg, setsuccess_dlg] = useState(false)
  const [success_dlg_noaction, setsuccess_dlg_noaction] = useState(false)
  const [error_alert, seterror_alert] = useState(false)
  const [redirect_alert, setredirect_alert] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")

  const [language, setLanguage] = useState("eng")

  const multiLanguageHandler = data => {
    switch (language) {
      case "eng":
        return data.en
      case "cn":
        return data.cn ? data.cn : data.en
      case "jp":
        return data.jp ? data.jp : data.en
      default:
        return data.en
    }
  }

  return (
    <React.Fragment>
      <div>
        <MetaTags>
          <title>Ugift</title>
        </MetaTags>
        <Container fluid className="p-0">
          <Row className="g-0">
            {success_dlg_noaction ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  setsuccess_dlg_noaction(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {success_dlg ? (
              <SweetAlert
                success
                title={dynamic_title}
                onConfirm={() => {
                  // history.push("/basket")
                  // history.push("/checkout-cardselection")
                  if (basketData.products.length == 0) {
                    // history.push("/checkout-cardselection")
                    updateOrderStatus()
                  } else {
                    history.push("/basket")
                  }
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {error_alert ? (
              <SweetAlert
                title={dynamic_title}
                danger
                onConfirm={() => {
                  seterror_alert(false)
                }}
              >
                {dynamic_description}
              </SweetAlert>
            ) : null}
            {redirect_alert ? (
              <SweetAlert
                title={dynamic_title}
                onCancel={() => {
                  setredirect_alert(false)
                }}
                customButtons={<React.Fragment></React.Fragment>}
              >
                <React.Fragment>
                  <Row className="px-3 py-2">
                    <button
                      className="btn btn-primary waves-effect waves-light font-size-15 me-2"
                      onClick={() => {
                        setredirect_alert(false)
                        history.push("/login")
                      }}
                    >
                      {props.t("Login")}
                    </button>
                  </Row>
                  <Row className="px-3 py-2">
                    <button
                      className="btn btn-light waves-effect waves-light font-size-15"
                      onClick={() => {
                        setredirect_alert(false)
                      }}
                    >
                      {props.t("Cancel")}
                    </button>
                  </Row>
                </React.Fragment>
              </SweetAlert>
            ) : null}
            <Col
              xl={6}
              className="mx-auto"
              style={{
                maxWidth: "480px",
                backgroundColor: "white",
                // backgroundImage: `url(${bgImage})`,
                // backgroundSize: "cover",
              }}
            >
              {/* <img
                src={bgImage}
                alt=""
                style={{
                  position: "absolute",
                  objectFit: "contain",
                  maxWidth: "480px",
                }}
              /> */}
              <div
                className="auth-full-page-content"
                style={{
                  minHeight: "100vh",
                  backgroundColor: "#F5F5F5",
                  paddingTop: "60px",
                }}
              >
                <div className="w-100">
                  <div className="d-flex flex-column h-100">
                    <Row
                      className="m-0 w-100"
                      style={{
                        height: "56px",
                        backgroundColor: "#009FE2",
                        position: "fixed",
                        top: 0,
                        zIndex: 1030,
                        maxWidth: "480px",
                      }}
                    >
                      <Col xs={2} className="ps-0">
                        {/* <Link to="/home"> */}
                        <Button
                          className="h-100 m-0"
                          onClick={() => {
                            history.goBack()
                          }}
                        >
                          <i className="bx bx-arrow-back align-middle font-size-20 text-white" />
                        </Button>
                        {/* </Link> */}
                      </Col>
                      <Col xs={8} className="align-self-center">
                        <p className="h-100 text-white font-size-15 my-auto text-center">
                          {/* {giftData && giftData.giftcard_name} */}
                          {props.t("Customise a Gift Card")}
                        </p>
                      </Col>
                      <Col xs={2} className="pe-0">
                        <Link to="/basket">
                          <Button className="h-100 m-0">
                            <i
                              className="bx bx-basket align-middle text-white"
                              style={{ fontSize: "28px" }}
                            />
                            {!isGuest && basketCount != 0 && (
                              <span
                                className="badge bg-danger rounded-pill"
                                style={{
                                  position: "absolute",
                                  top: 12,
                                  right: 8,
                                }}
                              >
                                {basketCount}
                              </span>
                            )}
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Card
                          className="shadow-none mb-3 p-3"
                          style={{
                            // borderRadius: "12px",
                            // width: "160px",
                            // height: "196px",
                            backgroundColor: "white",
                          }}
                        >
                          {giftData && (
                            <CardImg
                              top
                              className="img-fluid mb-3"
                              src={giftData.image_thumbnail}
                              alt=""
                              style={{
                                aspectRatio: "3/2",
                                objectFit: "cover",
                                borderRadius: "14px",
                              }}
                            />
                          )}
                          <button
                            className="btn btn-outline-dark mt-0 font-size-18"
                            onClick={() => {
                              if (!isGuest) updateGiftCardId()
                              else {
                                setredirect_alert(true)
                                setdynamic_title(
                                  props.t("Welcome, please login to continue")
                                )
                              }
                            }}
                          >
                            {props.t("Send a card")}
                          </button>
                        </Card>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col>
                        <em
                          className="ms-3"
                          style={{ display: "inline-block" }}
                        >
                          {props.t(
                            "Attach a gift card from an assortment of brands along with your card. Don't worry, you may still change your selected gift card on the checkout page."
                          )}
                        </em>
                      </Col>
                    </Row>
                    {giftData &&
                      giftData.related_products &&
                      giftData.related_products.map((productData, index) => (
                        <Row
                          className="g-0"
                          style={{ backgroundColor: "white" }}
                        >
                          <Col className="px-3 mb-0">
                            <Link
                              to={"/product-details?id=" + productData.id}
                              onClick={() => {
                                localStorage.setItem("gid", giftcardId)
                              }}
                            >
                              <Card
                                className="py-3 mb-0 shadow-none"
                                key={`productData-${index}`}
                                style={{
                                  borderRadius: "0",
                                  borderBottom: "1px",
                                  borderBottomColor: "#D6D6D6",
                                  borderBottomStyle: "solid",
                                }}
                              >
                                <Row>
                                  <Col xs="auto">
                                    <img
                                      src={productData.image}
                                      className="avatar-lg"
                                      alt=""
                                      style={{
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </Col>
                                  <Col>
                                    <Row>
                                      <Col>
                                        <strong>
                                          <span className="font-size-15 text-dark">
                                            {
                                              multiLanguageHandler(
                                                productData.multiple_languages
                                              ).name
                                            }
                                          </span>
                                        </strong>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col xs="auto">
                                        <span className="font-size-15 text-dark">
                                          {productData.campaign_info &&
                                            (productData.campaign_info
                                              .discount_mode
                                              ? currency +
                                                " " +
                                                productData.campaign_info
                                                  .discounted_price
                                              : currency +
                                                " " +
                                                productData.discounted_price)}
                                        </span>
                                      </Col>
                                      <Col xs="auto">
                                        <span className="font-size-15 text-muted">
                                          <s>
                                            {productData.original_price !=
                                              productData.discounted_price &&
                                              currency +
                                                " " +
                                                productData.original_price}
                                          </s>
                                        </span>
                                      </Col>
                                    </Row>
                                    {productData.campaign_info &&
                                      (productData.campaign_info
                                        .discount_mode ? (
                                        <Row className="mt-3">
                                          <Col>
                                            <i className="bx bxs-discount align-middle font-size-20 text-danger me-2" />
                                            <span className="font-size-15 text-dark align-middle">
                                              {productData.campaign_info &&
                                                productData.campaign_info
                                                  .discount_message}
                                            </span>
                                          </Col>
                                        </Row>
                                      ) : null)}
                                  </Col>
                                </Row>
                              </Card>
                            </Link>
                          </Col>
                        </Row>
                      ))}
                    <Row>
                      <Col>
                        <Card body className="shadow-none">
                          <Link
                            to="/categories"
                            className="btn btn-outline-dark waves-effect waves-light font-size-18"
                            onClick={() => {
                              if (!isGuest)
                                localStorage.setItem("gid", giftcardId)
                            }}
                          >
                            {props.t("Add more gifts")}
                          </Link>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withTranslation()(CardProducts)

CardProducts.propTypes = {
  t: PropTypes.any,
}
